import { React, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack, Typography, Box, Button } from "@mui/material";
import Select from "@mui/material/Select";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { NavLink } from "react-router-dom";
import "./CourseMasterData.css";
import THManageNominationCourselist from "./THManageNominationCourselist";
import InputLabel from "@mui/material/InputLabel";
import SearchCourse from "./SearchCourse";
import {
 //  getNominationListData,
 //  getFilteredNominationListData,
 updateTHStatus,
 getNominatedCourseListTH,
 getNominatedUserListTH,
 downloadRangeNominatedUserListTH,
 getNominatedCount,
 getAllNominationDataTH,
 getCount,
} from "../Redux/THSlice";
import { getCurrentMonth } from "../Redux/BussinessPOCSlice";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { useTabContext } from "../../TabContext";

const convertToDate = (dateString) => {
   const [day, month, year] = dateString.split('/');
   return new Date(year, month - 1, day);
 };
 const getCurrentMonthRange = () => {
   const now = new Date();
   const start = new Date(now.getFullYear(), now.getMonth(), 1);
   const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
   return [start, end];
 };
const THManageNomination = () => {
 const [filter, setFilter] = useState(1);
 const [isSelected, setIsSelected] = useState(() => {
   const saved = localStorage.getItem('isSelected');
    return saved !== null ? JSON.parse(saved) : false;
});
 const [courseName, setCourseName] = useState( () => {
   const saved = localStorage.getItem('courseName');
    return saved !== null ? JSON.parse(saved) : '';
});
 const [courseCode, setCourseCode] = useState(() => {
   const saved = localStorage.getItem('courseCode');
    return saved !== null ? JSON.parse(saved) : '';
});
 const [startDate, setStartDate] = useState(() => {
   const saved = localStorage.getItem('startDate');
    return saved !== null ? JSON.parse(saved) : '';
});
 const [totalSeats, setTotalSeats] = useState(() => {
   const saved = localStorage.getItem('totalSeats');
    return saved !== null ? JSON.parse(saved) : '';
});
 const [filteredTrainingListStatus, setFilteredTrainingListStatus] = useState(0);
 const [filteredTrainingList, setFilteredTrainingList] = useState([]);
 const [selectDate, setSelectDate] = useState([]);
 const [dateRange, setDateRange] = useState(getCurrentMonthRange());
 const {activePage, setActivePage} = useTabContext();

 const currentMonthIndex = useSelector((state) => state.poc.currentMonthIndex);
 const [month, setMonth] = useState(currentMonthIndex);
 const nominatedCourseListTH = useSelector(
   (state) => state.traininghost.nominatedCourseListTH
  ) ?? false
 useEffect(() => {
  setMonth(currentMonthIndex);
 }, [currentMonthIndex]);

 useEffect(() => {
   handleDateChange(dateRange);
 }, [dateRange, nominatedCourseListTH]);
 const [page, setPage] = useState(0);
 const [rowsPerPage, setRowsPerPage] = useState(10);
 const [filteredData, setFilteredData] = useState(nominatedCourseListTH)
 const dispatch = useDispatch();
 //  const nominationList = useSelector((state) => state.poc.nominationData);
 const downloadAllnominatedCourseListTHData = filteredData?.map((item) => ({courseCode :item.courseCode, 
   startDate: item.startDate}))
 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };
 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
 };

 const handleNominatedCourseSelection = (code, date, coursename, seats) => {
  dispatch(getNominatedUserListTH(code, date));
  setCourseName(coursename);
  setIsSelected(true);
  setActivePage(true)
  setCourseCode(code);
  localStorage.setItem('isSelected', JSON.stringify(true));
  localStorage.setItem('courseName', JSON.stringify(coursename));
  localStorage.setItem('courseCode', JSON.stringify(code));
  localStorage.setItem('startDate', JSON.stringify(date));
  localStorage.setItem('totalSeats', JSON.stringify(seats));
  setStartDate(date);
  setTotalSeats(seats);
  dispatch(getCount(code, date));
  dispatch(getNominatedCount(code, date));
 };
 useEffect(() =>{
   if (isSelected) {
      dispatch(getNominatedUserListTH(courseCode, startDate));
      dispatch(getCount(courseCode, startDate));
      dispatch(getNominatedCount(courseCode, startDate));
    }
 }, [isSelected])
 console.log(isSelected,courseCode, startDate,courseName ,totalSeats)
 const handleSetIsSelected = (value) => {
   setIsSelected(value);
   localStorage.setItem('isSelected', JSON.stringify(value));
 };
 useEffect(() => {
  //   dispatch(getFilteredNominationListData(filter));
  dispatch(getNominatedCourseListTH());
  dispatch(getCurrentMonth());
 }, []);
 const theme = createTheme({
  typography: {
   fontFamily: "Graphik-Regular",
  },
  minHeight: "420px"
 });
//  const handleChange = (event) => {
//   setMonth(event.target.value);
//   const monthNames = [
//    "January",
//    "February",
//    "March",
//    "April",
//    "May",
//    "June",
//    "July",
//    "August",
//    "September",
//    "October",
//    "November",
//    "December",
//   ];

//   setMonth(event.target.value);
//   //   const selectedMonthName = monthNames[event.target.value - 1];
//  };

const handleDateChange = (range) => {
   const [start, end] = range;
   if (start && end) {
     const filtered = nominatedCourseListTH.filter(item => {
       const itemDate = convertToDate(item.startDate);
       return itemDate >= start && itemDate <= end;
     });
     setFilteredData(filtered);
   } else {
     setFilteredData(nominatedCourseListTH);
   }
 };
 const handleRangeCancel = () => {
   const defaultRange = getCurrentMonthRange();
    setDateRange(defaultRange);
 }
const downloadExcel = () => {
   dispatch(downloadRangeNominatedUserListTH(downloadAllnominatedCourseListTHData))
}
 return (
  <ThemeProvider theme={theme} >
   {!isSelected && 
   <Box className="key-functions">   
      <SearchCourse  trainingList={filteredData} setFilteredTrainingList={setFilteredTrainingList} setFilteredTrainingListStatus={setFilteredTrainingListStatus} />
      <Box className="select_daterange_section">
         <p>Select Date Range: </p>
     <DateRangePicker
          value={dateRange}
          onChange={(range) => setDateRange(range)}
          placeholder="Select Date Range"
          style={{ width: 260 }}
          onClean={handleRangeCancel}
        />
    </Box>
   { filteredData.length > 0 && <Button onClick={downloadExcel} variant="contained">
          Download
        </Button>
}
   </Box> }
   {!isSelected ? (
    filteredData.length != 0 ? (
     <Box className="upload_fetch_table" sx={{minHeight:"420px"}}>
      {/* <Typography
       sx={{ fontSize: "1.17em", margin: "20px 0px 20px 0px", fontWeight: "600" }}
      >
       Nomination List for SAP Integration
      </Typography> */}
      {/* <h3 className="upload_section_header">Nomination List for SAP Integration</h3> */}
      <Paper sx={{ width: "100% !important" }}>
       <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
         <TableHead>
          <TableRow>
           <TableCell align="center">Sl No</TableCell>
           <TableCell align="center">Course Name</TableCell>
           <TableCell align="center">Course Code</TableCell>
           <TableCell align="center">Start Date</TableCell>
           <TableCell align="center">Batch Size</TableCell>
          </TableRow>
         </TableHead>
         <TableBody>            
            {filteredData.length != 0 && filteredTrainingListStatus === 0 &&
               <ManageNominationTableList filteredData={filteredData} page={page} rowsPerPage={rowsPerPage} handleNominatedCourseSelection={handleNominatedCourseSelection}/>}
            {filteredData.length != 0 && filteredTrainingListStatus === 1 && 
               <ManageNominationTableList filteredData={filteredTrainingList} page={page} rowsPerPage={rowsPerPage} handleNominatedCourseSelection={handleNominatedCourseSelection}/>}
            {filteredData.length != 0 && filteredTrainingListStatus === 1 && filteredTrainingList.length === 0 && 
               <TableRow><TableCell>Searched courses not found.</TableCell></TableRow>} 
         </TableBody>
        </Table>
       </TableContainer>
       <TablePagination
        className="manageNomination_pagination"
        component="div"
        count={filteredData.length != 0 ? filteredData.length : null}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ width: "100% !important" }}
       />
      </Paper>
     </Box>
    ) : (
     <Stack
      justifyContent={"center"}
      alignItems={"center"}
      sx={{ marginTop: "30px", marginBottom: "100px" , minHeight:"420px"}}
     >
      <Stack
       spacing={2}
       justifyContent={"center"}
       alignItems={"center"}
       sx={{
        border: "solid 1px #DEDEDE",
        borderRadius: "5px",
        width: "40%",
        padding: "30px",
       }}
      >
       <img style={{ width: "100px" }} src="/images/POC/norecords.png"></img>
       <Stack direction={"row"} spacing={1}>
        <img
         style={{ width: "20px", height: "20px", marginTop: "3px" }}
         src="/images/POC/norecordsalert.png"
        ></img>
        <Typography>No Records Found</Typography>
       </Stack>
      </Stack>
     </Stack>
    )
   ) : (
    <THManageNominationCourselist
     setIsSelected={handleSetIsSelected}
     setActivePage={setActivePage}
     courseName={courseName}
     courseCode={courseCode}
     startDate={startDate}
     totalSeats={totalSeats}
    />
   )}
  </ThemeProvider>
 );
};

function ManageNominationTableList({filteredData, page, rowsPerPage, handleNominatedCourseSelection}) {
   return <>
      {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
         <TableRow key={index} sx={{ cursor: "pointer" }} onClick={() => {handleNominatedCourseSelection(item.courseCode,item.startDate,item.courseName,item.totalSeats);}}>
            <TableCell align="center" scope="row">
               {item.sno}
            </TableCell>
            <TableCell align="center">{item.courseName}</TableCell>
            <TableCell align="center">{item.courseCode}</TableCell>
            <TableCell align="center">{item.startDate}</TableCell>
            <TableCell align="center">{item.totalSeats}</TableCell>
         </TableRow>
      ))}
   </>
}

export default THManageNomination;
